import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMessages from "@faire/web-api--source/routes/brand-portal/messages";
import articlePage from "@faire/web-api--source/routes/support/articles/articleId";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const VatIssueIA: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="For an order that is shipping cross-border within the EU, Faire will charge VAT at checkout, based on the ship to country. If the retailer has not provided a VAT number, here are some steps you can take:"
          description={{
            text: "A step-by-step guide to cannot find an order",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Message the retailer:</BoldFormatting>"
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The first step title in the VAT issue",
              }}
            />
          </Typography>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Use <ButtonFormatting>Faire messaging</ButtonFormatting> to reach out to the retailer directly to inquire if the retailer has a VAT number that is registered for intra-Community trade. If the retailer confirms they do have a VAT number for intra-Community trade, then ask the retailer to add their VAT number to their own account settings on Faire to ensure the correct VAT treatment is applied. This should result in 0% VAT being applied to unfulfilled orders from EU brands."
              description={{
                text: "The first step content in the VAT issue",
              }}
              values={{
                ButtonFormatting: (chunks: JSX.Element) =>
                  FaireMessagingFormatting(chunks),
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="<BoldFormatting>Postpone fulfillment:</BoldFormatting>"
              values={{
                BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
              }}
              description={{
                text: "The second step title in the VAT issue",
              }}
            />
          </Typography>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Consider postponing the shipment of the order until the retailer has the opportunity to add their VAT number to their account. For further comprehensive guidelines, visit <LinkFormatting>How does VAT work for E.U. orders</LinkFormatting>?"
              values={{
                LinkFormatting: (chunks: JSX.Element) => HCFormatting(chunks),
              }}
              description={{
                text: "The second step content in the VAT issue",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
    </Column>
  );
};

const FaireMessagingFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMessages()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);

const HCFormatting = (chunks: JSX.Element) => (
  <Button
    variant="tertiary"
    linkTo={articlePage("360057747911")}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
